import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import cn from 'classnames';
import type { MenuItem } from '@/shared/types/common';
import { CHAT_UNREAD_BADGE_CLASS } from '@/features/Chat';
import { Svg } from '@/shared/ui/Svg';
import styles from '../../ui/Sidebar/Sidebar.module.scss';

export const SimpleMenuItem = ({
  item,
  pathname,
  badgeCount,
}: {
  item: MenuItem;
  pathname: string;
  badgeCount?: number;
}) => {
  const navigate = useNavigate();
  const isActive =
    item.href &&
    (pathname === item.href || (item.href !== '/' && pathname.startsWith(`${item.href}/`)));

  return (
    <Link
      to={item.href || ''}
      onClick={(e) => {
        e.preventDefault();
        if (item.href) {
          navigate(item.href);
        }
      }}
      data-menu-active={isActive ? 'true' : undefined}
      className={cn(styles.listBoxItemBase, {
        ['bg-red']: isActive,
        [styles.active]: isActive,
      })}
    >
      <div className="flex items-center gap-3 w-full">
        {item.icon && (
          <Svg
            Icon={item.icon}
            className={cn({ ['!text-white']: isActive })}
            width={24}
            height={24}
          />
        )}
        <span
          className={cn(styles.listBoxTitle, {
            ['!text-white']: isActive,
          })}
        >
          {item.label}
        </span>
        {badgeCount != null && badgeCount > 0 ? (
          <span className={cn(CHAT_UNREAD_BADGE_CLASS, 'ml-auto')}>
            {badgeCount > 99 ? '99+' : badgeCount}
          </span>
        ) : null}
      </div>
    </Link>
  );
};
